import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Thing, WithContext } from "schema-dts";

export interface IProps<T extends Thing> {
  data: WithContext<T>;
}
// eslint-disable-next-line react/prefer-stateless-function
export default class JsonLD<T extends Thing> extends React.Component<
  IProps<T>
> {
  public render() {
    const { data } = this.props;

    return (
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      />
    );
  }
}
